<!-- profile.component.html -->
<div class="container mx-auto p-8">
  <div class="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-6">
    <h1 class="text-3xl font-bold mb-6">Mi Perfil</h1>

    <div class="space-y-6">
      <!-- Información del Usuario -->
      <div class="bg-gray-50 p-4 rounded-lg">
        <h2 class="text-xl font-semibold mb-4">Información Personal</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Nombre</label>
            <p class="mt-1 text-gray-900">{{user?.name}}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Email</label>
            <p class="mt-1 text-gray-900">{{user?.email}}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Rol</label>
            <p class="mt-1 text-gray-900">{{user?.role}}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Fecha de Registro</label>
            <p class="mt-1 text-gray-900">{{user?.createdAt | date:'dd/MM/yyyy'}}</p>
          </div>
        </div>
      </div>

      <!-- Estadísticas -->
      <div class="bg-gray-50 p-4 rounded-lg">
        <h2 class="text-xl font-semibold mb-4">Estadísticas</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="text-center p-4 bg-blue-50 rounded-lg">
            <p class="text-2xl font-bold text-blue-600">{{stats?.totalOrders || 0}}</p>
            <p class="text-sm text-gray-600">Órdenes Totales</p>
          </div>
          <div class="text-center p-4 bg-green-50 rounded-lg">
            <p class="text-2xl font-bold text-green-600">{{stats?.activeOrders || 0}}</p>
            <p class="text-sm text-gray-600">Órdenes Activas</p>
          </div>
          <div class="text-center p-4 bg-purple-50 rounded-lg">
            <p class="text-2xl font-bold text-purple-600">{{stats?.completedOrders || 0}}</p>
            <p class="text-sm text-gray-600">Órdenes Completadas</p>
          </div>
        </div>
      </div>

      <!-- Acciones -->
      <div class="flex justify-end space-x-4">
        <button (click)="editProfile()" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center">
          <i class="fas fa-edit mr-2"></i>
          Editar Perfil
        </button>
        <button (click)="changePassword()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center">
          <i class="fas fa-key mr-2"></i>
          Cambiar Contraseña
        </button>
      </div>
    </div>
  </div>
</div> 